export enum WorkbenchType {
    QC,
}

export interface IViewState {
    latitude: number;
    longitude: number;
    zoom: number;
}
